import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Intake } from 'models/IntakeModel';


const IntakeList: React.FC = () => {
  const width = { name: 25, date:20, phone:25, email:25  }
  const [formId, formName] = [Code.Form.Id.INTAKE, Code.Form.Name.INTAKE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [intakeData, setIntakeData] = useState<Intake[]>([]); 
  const [selectedIntake, setselectedIntake] = useState<Intake | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();


  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Intake.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Intake.FirstName, 
        Name.Intake.LastName,
        Name.Intake.Date, 
        Name.Intake.Phone, 
        Name.Intake.Email
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
    });
     
    await API.Data.List<Intake>(url, setIntakeData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, intakeData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Date, width.date],
                [Title.ClientName, width.name], 
                [Title.Phone, width.phone],
                [Title.Email, width.email]
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(intakeData) && (
              <Control.Grid.Row>
                {intakeData.map((intakeData) => { return (
                <Control.Grid.Data<Intake> key={intakeData.intake_id} itemKey={intakeData.intake_key} data={intakeData} setMenuPosition={setMenuPosition} setSelectedData={setselectedIntake} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={intakeData.intake_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, intakeData.intake_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [Utility.Format.DateOnly(intakeData.intake_date), width.date], 
                    [`${intakeData.intake_first_name} ${intakeData.intake_last_name}`, width.name], 
                    [intakeData.intake_phone, width.phone], 
                    [intakeData.intake_email, width.email]
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={intakeData.intake_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={intakeData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedIntake?.intake_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedIntake?.intake_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default IntakeList;